class AstroButton extends HTMLButtonElement {
	static get observedAttributes() {
		return ['data-display-spinner'];
	}

	constructor() {
		super();
		this.render();
	}

	connectedCallback() {
		this.addEventListener('click', this.handleClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.handleClick);
	}

	attributeChangedCallback(name: string, oldValue: string, newValue: string) {
		if (name === 'data-display-spinner' && newValue === 'true') {
			this.showSpinner();
		} else if (name === 'data-display-spinner' && newValue === 'false') {
			this.hideSpinner();
		}
	}

	handleClick() {
		if (this.getAttribute('type') === 'submit') {
			const closestForm = this.closest('form');
			if (closestForm && closestForm.checkValidity()) {
				this.showSpinner();
			}
		}
	}

	showSpinner() {
		const spinner = this.querySelector('.spinner-border');
		const content = this.querySelector('[data-btn-content]');

		spinner?.classList.remove('d-none');
		content?.classList.add('opacity-0');
		content?.setAttribute('aria-hidden', 'true');

		this.classList.add('pe-none');
		this.classList.add('disabled');
		this.setAttribute('tabindex', '-1');
		this.setAttribute('aria-disabled', 'true');
	}

	hideSpinner() {
		const spinner = this.querySelector('.spinner-border');
		const content = this.querySelector('[data-btn-content]');

		spinner?.classList.add('d-none');
		content?.classList.remove('opacity-0');
		content?.removeAttribute('aria-hidden');

		this.classList.remove('pe-none');
		this.classList.remove('disabled');
		this.removeAttribute('tabindex');
		this.removeAttribute('aria-disabled');
	}

	render() {
		const originalContent = this.innerHTML;

		const spinnerElement = document.createElement('span');
		spinnerElement.className =
			'd-none spinner-border spinner-border-sm position-absolute';
		spinnerElement.setAttribute('role', 'status');
		spinnerElement.setAttribute('aria-hidden', 'true');

		const contentWrapper = document.createElement('span');
		contentWrapper.setAttribute('data-btn-content', '');
		contentWrapper.innerHTML = originalContent;

		this.innerHTML = '';
		this.classList.add(
			'd-inline-flex',
			'position-relative',
			'justify-content-center',
			'align-items-center'
		);
		this.appendChild(spinnerElement);
		this.appendChild(contentWrapper);
	}
}

customElements.define('astro-button', AstroButton, { extends: 'button' });
